import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SessionTimeOutComponent } from "../components/session-time-out/session-time-out.component";
import { ConfigService } from "../core/services/config/config.service";
import { MatDialog } from "@angular/material/dialog";
import { SessionService } from "../core/services/session/session.service";

@Injectable({
	providedIn: 'root'
})
export class HttpRequestInterceptor implements HttpInterceptor {

	constructor(protected configService: ConfigService, protected sessionService: SessionService, protected dialog: MatDialog) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//Header 
		let headers = request.headers.append("X-Requested-With", "XMLHttpRequest")
		if (this.configService.config.isEmpty() == false) {
			headers = headers.append("X-Entity-With", this.configService.config.getEntityHeader())
		} else {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const entityParam = urlParams.get('X-Entity-With')
			if (entityParam != null) {
				headers = headers.append("X-Entity-With", '' + entityParam)
			}
		}

		//Static resources
		let modPath = environment.http_request_path
		if (request.url.startsWith("assets") == true || request.url.startsWith("http") == true || request.responseType == 'arraybuffer') {
			modPath = ""
		}
		let cloned = request.clone({ headers: headers, url: modPath + request.url })

		return next.handle(cloned).pipe(tap((event: HttpEvent<any>) => { return event }, (error: HttpErrorResponse) => {
			if (error.status == 666 || error.status == 502 || error.status == 667 || error.status == 504) {
				const hasWrongEntityHeader = error.headers?.get('X-Wrong-Entity') === 'true'
				const errorCode = error.status == 502 && hasWrongEntityHeader ? 667 : error.status

				console.log("----response----");
				console.error("status code:");
				console.error(errorCode);
				console.error(error.message);
				console.log("--- end of response---");
				setTimeout(() => {
					console.log("Reload page is needed!!!")

					if (this.configService.isInitEndPoint(request.url) && (errorCode == 666 || errorCode == 502) && !this.configService.initializationAttempted) {
                        this.configService.initializationAttempted = true
                        this.sessionService.reloadToRoot()
                    	return
                    }

					let opened = this.dialog.openDialogs.filter(d => {
						if (d.componentInstance instanceof SessionTimeOutComponent) {
							return true
						}
						return false
					})

					if (opened.length > 0) {
						return
					}

					this.dialog.open(SessionTimeOutComponent, {
						position: { top: "40px" },
						hasBackdrop: true,
						panelClass: "no-dialog-borders",
						disableClose: true,
						data: { code: errorCode }
					})

				}, 10)
			}
			return error

		}));
	}

}
